import type { NMessages } from '@pages/Messages/MessagesList/Messages.types';

import type { ColumnsType } from 'antd/es/table';

export const M_DATE = 'date';
export const M_TYPE = 'type';
export const M_CHANEL = 'chanel';
export const M_INTEGRATION = 'integration';
export const M_USER = 'user';
export const M_CLIENT = 'client';
export const M_STATUS = 'status';
export const M_MESSAGE = 'message';

export const COLUMNS: ColumnsType<NMessages.Columns> = [
  {
    title: 'Дата и время',
    dataIndex: M_DATE,
    key: M_DATE,
    width: 145,
  },
  {
    title: 'Тип',
    dataIndex: M_TYPE,
    key: M_TYPE,
    width: 105,
  },
  {
    title: 'Канал',
    dataIndex: M_CHANEL,
    key: M_CHANEL,
    width: 120,
  },
  {
    title: 'Интеграция',
    dataIndex: M_INTEGRATION,
    key: M_INTEGRATION,
    width: 150,
  },
  {
    title: 'Пользователь',
    dataIndex: M_USER,
    key: M_USER,
    width: 145,
  },
  {
    title: 'Клиент',
    dataIndex: M_CLIENT,
    key: M_CLIENT,
    width: 145,
  },
  {
    title: 'Статус',
    dataIndex: M_STATUS,
    key: M_STATUS,
    width: 110,
  },
  {
    title: 'Сообщение',
    dataIndex: M_MESSAGE,
    key: M_MESSAGE,
  },
];
